import classNames from 'classnames';
import PropTypes from 'prop-types';

const FilterIcon = ({ className }) => {
  const iconClassName = classNames('filter-icon', className);

  return (
    <svg className={iconClassName} width='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.99828 13.7533C10.0249 13.9533 9.95828 14.1667 9.80494 14.3067C9.54494 14.5667 9.12494 14.5667 8.86494 14.3067L6.19161 11.6333C6.03828 11.48 5.97161 11.2733 5.99828 11.08V7.66667L2.80494 3.58C2.57828 3.29333 2.63161 2.87333 2.91828 2.64667C3.04494 2.55333 3.18494 2.5 3.33161 2.5H12.6649C12.8116 2.5 12.9516 2.55333 13.0783 2.64667C13.3649 2.87333 13.4183 3.29333 13.1916 3.58L9.99828 7.66667V13.7533ZM4.69161 3.83333L7.33161 7.20667V10.8867L8.66494 12.22V7.2L11.3049 3.83333H4.69161Z'
        fill='currentColor'
      />
    </svg>
  );
};

FilterIcon.propTypes = {
  className: PropTypes.string,
};

export default FilterIcon;
